"use client"

import Script from "next/script";
import {CIO_IN_APP_ENABLED, CIO_SITE_ID, CIO_TRACK_ASSET, isCioEnabled} from "@/lib/analytics/customerio";

/**
 * Loads the Customer.io Journeys JavaScript snippet. The asset (US track.js vs
 * EU track-eu.js) is chosen by `NEXT_PUBLIC_CIO_REGION` to match the account's
 * region per environment. Only the public Site ID is used; the secret Track API
 * key never reaches the browser. Renders nothing when `NEXT_PUBLIC_CIO_SITE_ID`
 * is unset (AC-613).
 *
 * The snippet also boots the in-app message renderer (`data-use-in-app`),
 * letting Journeys campaigns display modals, banners and tooltips on the site
 * without frontend releases. Opt out per environment with
 * `NEXT_PUBLIC_CIO_IN_APP=false`.
 */
export default function CustomerIoScript() {
    if (!isCioEnabled()) return null;

    return (
        <Script id="customerio-tracker" strategy="afterInteractive"
                dangerouslySetInnerHTML={{
                    __html: `
                var _cio = _cio || [];
                (function() {
                  var a,b,c;
                  a = function(f) {
                    return function() {
                      _cio.push([f].concat(Array.prototype.slice.call(arguments, 0)));
                    };
                  };
                  b = ["load","identify","sidebar","track","page","on","off"];
                  for (c = 0; c < b.length; c++) { _cio[b[c]] = a(b[c]); }
                  var t = document.createElement('script'),
                      s = document.getElementsByTagName('script')[0];
                  t.async = true;
                  t.id = 'cio-tracker';
                  t.setAttribute('data-site-id', '${CIO_SITE_ID}');
                  t.setAttribute('data-use-array-params', 'true');
                  ${CIO_IN_APP_ENABLED ? `t.setAttribute('data-use-in-app', 'true');` : ""}
                  t.src = '${CIO_TRACK_ASSET}';
                  s.parentNode.insertBefore(t, s);
                })();
              `,
                }}/>
    );
}
